(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rc-card-gallery')) {
  customElements.define('rc-card-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.lifecycle) return;
      this.lifecycle = new AbortController();
      const { signal } = this.lifecycle;
      requestAnimationFrame(() => {
        if (signal.aborted) return;
        this.track = this.querySelector('.rc-card-gallery__track');
        this.template = this.querySelector('template');
        if (!this.track || !this.template) return;
        this.counter = this.querySelector('[aria-live]');
        this.index = 0;
        this.loaded = false;
        this.near = false;
        const mobile = matchMedia('(max-width: 699px)');
        const sync = () => {
          if (mobile.matches) {
            this.build(); this.dataset.ready = '';
            requestAnimationFrame(() => this.update());
          } else { delete this.dataset.ready; }
        };
        mobile.addEventListener('change', sync, { signal });
        this.track.addEventListener('scroll', () => {
          this.suppressUntil = Date.now() + 180;
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
        }, { passive: true, signal });
        this.addEventListener('click', e => {
          const button = e.target.closest('button[data-step]');
          if (button) {
            e.preventDefault();
            const next = Math.max(0, Math.min(this.images.length - 1, this.index + Number(button.dataset.step)));
            this.preload(next);
            this.track.scrollTo({ left: next * (this.track.getBoundingClientRect().width + 2), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          } else if (Date.now() < (this.suppressUntil || 0)) {
            e.preventDefault(); e.stopPropagation();
          }
        }, { capture: true, signal });
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.near = true; this.preload(this.index); this.observer.disconnect();
          }
        }, { rootMargin: '160px' });
        this.observer.observe(this);
        sync();
      });
    }
    build() {
      if (this.loaded) return;
      this.track.replaceChildren();
      this.images = [...this.template.content.querySelectorAll('img')].map((source, index) => {
        const link = document.createElement('a');
        link.className = 'rc-card-gallery__slide';
        link.href = this.track.dataset.href;
        link.setAttribute('aria-label', this.track.dataset.title + ' — image ' + (index + 1));
        const image = source.cloneNode(true);
        image.loading = 'lazy'; image.decoding = 'async'; image.draggable = false;
        link.append(image); this.track.append(link);
        return image;
      });
      this.style.setProperty('--rc-image-step', (100 / this.images.length) + '%');
      this.loaded = true;
      if (this.near) this.preload(this.index);
    }
    preload(index) {
      if (!this.images || !this.near) return;
      for (let i = Math.max(0, index - 1); i <= Math.min(this.images.length - 1, index + 1); i++) {
        if (this.images[i].dataset.rcWarmed) continue;
        this.images[i].dataset.rcWarmed = 'true';
        this.images[i].loading = 'eager';
        if (this.images[i].decode) this.images[i].decode().catch(() => {});
      }
    }
    update() {
      if (!this.images || !this.track.clientWidth) return;
      const position = Math.max(0, Math.min(this.images.length - 1, this.track.scrollLeft / (this.track.getBoundingClientRect().width + 2)));
      const index = Math.round(position);
      this.style.setProperty('--rc-image-offset', (position * 100) + '%');
      if (index !== this.index || !this.counter.textContent.trim()) this.counter.textContent = (index + 1) + '/' + this.images.length;
      this.index = index;
      this.preload(index);
      const buttons = this.querySelectorAll('button[data-step]');
      buttons[0].disabled = index === 0;
      buttons[1].disabled = index === this.images.length - 1;
    }
    disconnectedCallback() {
      this.lifecycle?.abort(); this.lifecycle = null;
      this.observer?.disconnect(); cancelAnimationFrame(this.frame); this.frame = 0;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
